import Stack from '@mui/material/Stack';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import Typography from '@mui/material/Typography';

export interface EventDayHolesToggleProps {
  numHoles?: number;          // undefined/18 = 18 holes
  which9?: 'front' | 'back';  // only meaningful when numHoles === 9
  size?: 'small' | 'medium';
  onChange: (numHoles: number, which9?: 'front' | 'back') => void;
}

// Round-length control: 18 vs 9 holes, plus front/back 9 when 9 is selected. Shared by the Event
// editor's day row (EventDay.numHoles/which9 — the day's own default) and the Competition editor
// (Competition.numHoles/which9 — a per-game override of that default).
export default function EventDayHolesToggle({ numHoles, which9, size = 'small', onChange }: EventDayHolesToggleProps) {
  return (
    <Stack spacing={0.5}>
      <Typography variant="caption" color="text.secondary">Holes</Typography>
      <ToggleButtonGroup
        exclusive
        size={size}
        value={numHoles === 9 ? 9 : 18}
        onChange={(_, val) => {
          if (val === null) return;
          onChange(val, val === 9 ? (which9 ?? 'front') : undefined);
        }}
      >
        <ToggleButton value={18}>18</ToggleButton>
        <ToggleButton value={9}>9</ToggleButton>
      </ToggleButtonGroup>
      {numHoles === 9 && (
        <ToggleButtonGroup
          exclusive
          size={size}
          value={which9 ?? 'front'}
          onChange={(_, val) => {
            if (val === null) return;
            onChange(9, val);
          }}
        >
          <ToggleButton value="front">Front</ToggleButton>
          <ToggleButton value="back">Back</ToggleButton>
        </ToggleButtonGroup>
      )}
    </Stack>
  );
}
